export const RoleSummaryMockData = [
  {
    id: '29a1b029-6b29-ed11-ae83-000d3a223767',
    name: 'MockRoleName',
    selector: 'MockRoleSelector',
    organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
    organization: 'MockRoleOrganization',
    addToScopeTypeCreator: 'MockRoleScope',
    permissions: [
      {
        permissionId: '0037618f-88dd-4859-8fa9-80b20279bca6',
        name: 'ManageSurveys',
        selector: 'Drillhole',
      },
      {
        permissionId: 'bf6d986d-32ac-4764-8d5e-5489467e7075',
        name: 'ViewDrillholeData',
        selector: 'Drillhole',
      },
    ],
  },
  {
    id: '28a1b029-6b29-ed11-ae83-000d3a223767',
    name: 'License Manager',
    selector: 'MockRoleSelector2',
    organizationId: '6c40c6c4-7405-4126-a60d-102f29fd2329',
    organization: 'MockRoleOrganization2',
    addToScopeTypeCreator: 'MockRoleScope',
    permissions: [
      {
        permissionId: '0037618f-88dd-4859-8fa9-80b20279bca6',
        name: 'ManageLicenses',
        selector: 'Organization',
      },
    ],
  },
] as any[];
